import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions, TopicStatus } from './index';

export type TopicCreateData = AnyObject

export type TopicCreateResponse = TopicCreateData

export interface TopicCreateBody {
  title: string,
  description: string,
  image: string,
  // usaStateId: number,
  // subCategoryId: string,
  // countryId: number,
  // categoryId: string,
  // seo: {},
  status: TopicStatus
}

export const topicCreate = (payload: TopicCreateBody): Action<TopicCreateBody> => ({
  type: actions.topicCreateTrigger.toString(),
  payload,
});

export const topicCreateClear = (): Action => ({
  type: actions.topicCreateClear.toString(),
});

export const topicCreateErrorClear = (): Action => ({
  type: actions.topicCreateErrorReset.toString(),
});

export function* topicCreateRequestSaga({ payload }: Action<TopicCreateBody>) {
  yield put({
    type: actions.topicCreateStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.topicCreateError.toString(),
      payload: {
        message: 'TopicCreate: Parameters not passed.',
      },
    });

    return;
  }

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}topics`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<TopicCreateData, TopicCreateResponse>(
    response,
    actions.topicCreateSuccess.toString(),
    actions.topicCreateError.toString(),
    false,
    (topicCreateData) => topicCreateData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.topicCreateTrigger.toString(),
    defaultProcessingSaga(
      topicCreateRequestSaga,
      {
        error: actions.topicCreateError.toString(),
        locationCancel: actions.topicCreateClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.topicCreateSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.topicCreateError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.topicCreateErrorReset.toString(),
    });
  });
}
